import React, { useEffect, useState } from "react";
import { JobBankService } from "../../services/jobBank.service";
import { JobBankHeader } from "./jobBankHeader";
import "./jobBank.scss";
import { Col, Row } from "antd";
import ContentBlocker from "../../components/contentBlocker/contentBlocker";
import {useValidTokenFromStorage} from "../../hooks/authHook";

export function JobBank() {
  const [jobs, setJobs] = useState([]);
  const [pages, setPages] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({
    occupationFilter: "",
    locationFilter: "",
    popularFilter: "",
  });
  const validateToken = useValidTokenFromStorage();

  useEffect(() => {
    searchPage();
  }, []);

  const searchPage = async (page = 1, count = 12, order = "Fecha") => {
    try {
      const {
        popularFilter,
        occupationFilter,
        locationFilter
      } = filters;

      const result = await JobBankService.getJobAll(
          page,
          count,
          popularFilter,
          occupationFilter,
          locationFilter,
          order,
      );

      if (!result) return;

      const {
        list = [],
        totalCount,
        totalPages
      } = result;

      setJobs(list);
      setTotalCount(totalCount);
      setCurrentPage(page);
      setTotalPages(totalPages);
      setPages(generatePagination(totalPages, page, order));

    } catch (error) {
      console.error("Error fetching jobs:", error);
    }
  };

  const generatePagination = (totalPages, currentPage, order) => {
    return Array.from({ length: totalPages }, (_, i) => {
      const index = i + 1;
      return (
          <li
              className={`page-item${currentPage === index ? " active" : ""}`}
              key={index}
          >
            <a className="page-link" onClick={() => searchPage(index, undefined, order)}>
              {index}
            </a>
          </li>
      );
    });
  };


  const returnPreviousPage = () => {
    if (currentPage > 1) searchPage(currentPage - 1);
  };

  const advanceNextPage = () => {
    if (currentPage < totalPages) searchPage(currentPage + 1);
  };

  const handleCleanFilters = () => {
    setFilters({
      occupationFilter: "",
      locationFilter: "",
      popularFilter: "",
    });
    searchPage();
  }

  useEffect(() => {
    searchPage();
  }, [filters.popularFilter]);

  return (
    <section className="container-page">
      <JobBankHeader
        title="Bolsa de trabajo"
        setFilters={setFilters}
        filters={filters}
        searchPage={searchPage}
        handleCleanFilters={handleCleanFilters}
      />
      <Row>
        <Col xs={24}>
          <div className="job-bank-counter">
            <p>
              <span>{totalCount}</span> empleos disponibles
            </p>
          </div>
        </Col>
      </Row>
        {jobs.length === 0 ? (
          <Row gutter={[25, 25]}>
            <div className="empty">
            <i className="icon-empty"></i>
            <p>No hay empleos disponibles</p>
          </div>
        </Row>
        ) : (
           <ContentBlocker
              content={jobs}
              typeContent={"jobBank"}
              limitArray={4}
              title={"¡Sigue buscando!"}
           />
        )}
        {validateToken && (<>
      {jobs.length <= 0 ? (
        ""
      ) : (
        <div className="job-bank-pagination mt-4">
          <nav className="pagination-jobs">
            <ul className="pagination">
              <li className="page-item">
                <a
                  className="page-link"
                  onClick={returnPreviousPage}
                  aria-label="Previous"
                >
                  <span aria-hidden="true">&laquo;</span>
                  <span className="sr-only">Previous</span>
                </a>
              </li>
              {pages}
              <li className="page-item">
                <a
                  className="page-link"
                  onClick={advanceNextPage}
                  aria-label="Next"
                >
                  <span aria-hidden="true">&raquo;</span>
                  <span className="sr-only">Next</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      )}</>)}
    </section>
  );
}
